import * as React from 'react';

import Navbar from "../../Layouts/Navbar";

import API from "../../Services/API";
import {toast} from "react-toastify";
import Toast from "../../Components/Toast";
import Loading from "../../Layouts/Loading";
import {useNavigate} from "react-router-dom";
import 'react-slideshow-image/dist/styles.css'
import Header from "../../Layouts/Header";


export default function Orders() {
    const navigate = useNavigate();

    const [isLoaded, setIsLoaded] = React.useState(false);
    const [orders, setOrders] = React.useState([]);


    React.useEffect(() => {
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        if (!token) {
            window.location.replace('/login')
        }

        let params = {
            count: 40,
            page: 1,
            list: 1,
            orderBy: 'created_at',
            orderType: 'desc',
            'processFor': 'Sales',
            status_id: 15,
            returned: 1
        }

        API.getOrders(params)
            .then((response) => {
                setOrders(response.data);
                setIsLoaded(true);
            })
            .catch((error) => {
                if (error.response) {
                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.message);
                }
            });

    }, []);


    return (
        <React.Fragment>
            <Toast/>
            {
                !isLoaded && <Loading/>
            }
            <Header hasBack={false} title='NGKH'/>

            <section className="section mt-4 pt-5 rtl">
                <div className="row mx-2 pb-5 mb-5">
                    <div className="col-12 text-center fw-bold text-small-1 mb-4 text-muted">
                        لیست محموله های مرجوعی
                    </div>
                    <div className="col-12">
                        <table className="table table-hover">
                            <thead>
                            <tr className='text-small-2 text-muted'>
                                <th scope="col">نماینده</th>
                                <th scope="col">تعداد باتری</th>
                                <th scope="col">کد پیگیری</th>

                            </tr>
                            </thead>
                            <tbody>
                            {
                                orders.map(order => {
                                    return (
                                        <tr key={order.id}
                                            role='button'
                                            onClick={() => navigate(`/returned-orders/${order.id}`)}
                                        >

                                            <td>
                                                {order.vendor.title}
                                                &nbsp;
                                                <span
                                                    className='text-small-2 text-muted'>({order.vendor.city})</span>
                                            </td>
                                            <td>
                                                {order.battery_qty}
                                            </td>
                                            <td>
                                                {order.tracking_code}
                                            </td>

                                        </tr>
                                    )
                                })
                            }
                            </tbody>
                        </table>
                    </div>


                </div>
            </section>
            <Navbar/>
        </React.Fragment>
    );
};
